import React, { useState } from "react";
import "./Footer.css";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email.trim()) return alert("Please enter a valid email.");
    alert(`Thanks for subscribing with ${email}`);
    setEmail("");
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="glass-footer">
      <div className="footer-container">
        <div className="footer-section brand">
          {/* Reserved for logo/branding if needed */}
        </div>

        {/* Left Section */}
        <div className="footer-section newsletter">
          <h1 className="footer-logo">Girls Degree College Skardu</h1>
          <ul>
            <li><strong>Code and Idea's Contributions</strong></li>
            <li>Mrs. Rehana Haider: Assistant Professor</li>
            <li>Mrs. Khadija Bano: Assistant Professor</li>
            <li>
              For more details please visit:{" "}
              <a
                href="https://gdcs.edu.pk"
                target="_blank"
                rel="noopener noreferrer"
              >
                gdcs.edu.pk
              </a>
            </li>
          </ul>
        </div>

        {/* Right Section */}
        <div className="footer-section socials">
          <ul>
            <li>Baltistan</li>
            <li><strong>Code and Idea's Contributions</strong></li>
            <li>Mrs. Saleema: Assistant Professor</li>
            <li>Mr. Sajid Ali: Lecturer</li>
            <li>Erf@n: Lecturer</li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Developed By Computer Science Department — All rights reserved
        </p>
        <button className="scroll-top" onClick={scrollTop}>↑</button>
      </div>
    </footer>
  );
};

export default Footer;
